import { parseSelectorPath as j } from "./ghl-ui.es1547.js";
import { isMediaOrSupports as $ } from "./ghl-ui.es1191.js";
const w = /[A-Z]/g;
function l(n) {
  return n.replace(w, (r) => "-" + r.toLowerCase());
}
function C(n, r = "  ") {
  return typeof n == "object" && n !== null ? ` {
` + Object.entries(n).map((f) => r + `  ${l(f[0])}: ${f[1]};`).join(`
`) + `
` + r + "}" : `: ${n};`;
}
function A(n, r, f) {
  return typeof n == "function" ? n({
    context: r.context,
    props: f
  }) : n;
}
function b(n, r, f, t) {
  if (!r)
    return "";
  const i = A(r, f, t);
  if (!i)
    return "";
  if (typeof i == "string")
    return `${n} {
${i}
}`;
  const u = Object.keys(i);
  if (u.length === 0)
    return f.config.keepEmptyBlock ? n + ` {
}` : "";
  const e = n ? [
    n + " {"
  ] : [];
  return u.forEach((o) => {
    const s = i[o];
    if (o === "raw") {
      e.push(`
` + s + `
`);
      return;
    }
    o = l(o), s != null && e.push(`  ${o}${C(s)}`);
  }), n && e.push("}"), e.join(`
`);
}
function x(n, r, f) {
  n && n.forEach((t) => {
    if (Array.isArray(t))
      x(t, r, f);
    else if (typeof t == "function") {
      const i = t(r);
      Array.isArray(i) ? x(i, r, f) : i && f(i);
    } else
      t && f(t);
  });
}
function y(n, r, f, t, i, u) {
  const e = n.$;
  let o = "";
  if (!e || typeof e == "string")
    $(e) ? o = e : r.push(e);
  else if (typeof e == "function") {
    const p = e({
      context: t.context,
      props: i
    });
    $(p) ? o = p : r.push(p);
  } else if (e.before && e.before(t.context), !e.$ || typeof e.$ == "string")
    $(e.$) ? o = e.$ : r.push(e.$);
  else if (e.$) {
    const p = e.$({
      context: t.context,
      props: i
    });
    $(p) ? o = p : r.push(p);
  }
  const s = j(r), c = b(s, n.props, t, i);
  o ? (f.push(`${o} {`), u && c && u.insertRule(`${o} {
${c}
}
`)) : (u && c && u.insertRule(c), !u && c.length && f.push(c)), n.children && x(n.children, {
    context: t.context,
    props: i
  }, (p) => {
    if (typeof p == "string") {
      const g = b(s, { raw: p }, t, i);
      u ? u.insertRule(g) : f.push(g);
    } else
      y(p, r, f, t, i, u);
  }), r.pop(), o && f.push("}"), e && e.after && e.after(t.context);
}
function O(n, r, f, t = !1) {
  const i = [];
  return y(n, [], i, r, f, t ? n.instance.__styleSheet : void 0), t ? "" : i.join(`

`);
}
export {
  O as render
};
